import { useState, useEffect } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import logo from "../assets/img/logo.png";
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon2 from "../assets/img/nav-icon2.svg";
import github from "../assets/img/github.svg";
import { BrowserRouter as Router } from "react-router-dom";
import ReactGA from "react-ga4";
import emailjs from "@emailjs/browser";
import { DownloadConfirmationModal } from "./DownloadConfirmationModal";
import Config from "../config/index";

ReactGA.initialize("G-NY8FSE5QD1");

export const NavBar = () => {
  const [activeLink, setActiveLink] = useState("home");
  const [scrolled, setScrolled] = useState(false);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const onUpdateActiveLink = (value) => {
    setActiveLink(value);

    ReactGA.event({
      category: "Navigation",
      action: `Clicked on ${value}`,
      label: value,
    });
  };

  const handleDownloadCV = (e) => {
    e.preventDefault();
    setShowModal(true);
  };

  const handleConfirmDownload = () => {
    // EmailJS Configuration
    const serviceId = `${Config.REACT_APP_EMAILJS_SERVICE_ID}`;
    const templateId = `${Config.REACT_APP_EMAILJS_TEMPLATE_ID}`;
    const publicKey = `${Config.REACT_APP_EMAILJS_PUBLIC_KEY}`;

    console.log(serviceId, templateId, publicKey);

    // Prepare email parameters
    const templateParams = {
      download_time: new Date().toLocaleString(),
      user_agent: navigator.userAgent,
      page_url: window.location.href,
    };

    // Send email notification via EmailJS
    emailjs
      .send(serviceId, templateId, templateParams, publicKey)
      .then(
        (response) => {
          console.log("Email sent successfully!", response.status, response.text);
        },
        (error) => {
          console.log("Email failed to send:", error);
        }
      );

    // Track with Google Analytics
    ReactGA.event({
      category: "Downloads",
      action: "Downloaded CV",
      label: "CV Download",
    });

    // Trigger CV download programmatically
    const link = document.createElement('a');
    link.href = '/cv.pdf';
    link.download = 'Ushan_Mihiranga_CV.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Router>
      <Navbar expand="md" className={scrolled ? "scrolled" : ""}>
        <Container>
          <Navbar.Brand href="/">
            <img src={logo} alt="Logo" />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav">
            <span className="navbar-toggler-icon"></span>
          </Navbar.Toggle>
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link
                href="#home"
                className={
                  activeLink === "home" ? "active navbar-link" : "navbar-link"
                }
                onClick={() => onUpdateActiveLink("home")}
              >
                <span className="nav-link-text">Home</span>
              </Nav.Link>
              <Nav.Link
                href="#skills"
                className={
                  activeLink === "skills" ? "active navbar-link" : "navbar-link"
                }
                onClick={() => onUpdateActiveLink("skills")}
              >
                <span className="nav-link-text">Skills</span>
              </Nav.Link>
              <Nav.Link
                href="#timeline"
                className={
                  activeLink === "timeline" ? "active navbar-link" : "navbar-link"
                }
                onClick={() => onUpdateActiveLink("timeline")}
              >
                <span className="nav-link-text">My Career Journey</span>
              </Nav.Link>
              <Nav.Link
                href="#projects"
                className={
                  activeLink === "projects"
                    ? "active navbar-link"
                    : "navbar-link"
                }
                onClick={() => onUpdateActiveLink("projects")}
              >
                <span className="nav-link-text">Projects</span>
              </Nav.Link>
            </Nav>
            <span className="navbar-text">
              <div className="social-icon">
                <a
                  href="https://www.linkedin.com/in/ushan-mihiranga-b25846296"
                  target="_blank"
                  rel="noreferrer"
                  onClick={() => {
                    ReactGA.event({
                      category: "Social Click",
                      action: "Clicked LinkedIn",
                      label: "LinkedIn Profile",
                    });
                  }}
                >
                  <img src={navIcon1} alt="LinkedIn Icon" />
                </a>
                <a
                  href="https://www.facebook.com/profile.php?id=100077429490019"
                  target="_blank"
                  rel="noreferrer"
                  onClick={() => {
                    ReactGA.event({
                      category: "Social Click",
                      action: "Clicked Facebook",
                      label: "Facebook Profile",
                    });
                  }}
                >
                  <img src={navIcon2} alt="Facebook Icon" />
                </a>
                <a
                  href="https://github.com/Ushan2001"
                  target="_blank"
                  rel="noreferrer"
                  onClick={() => {
                    ReactGA.event({
                      category: "Social Click",
                      action: "Clicked GitHub",
                      label: "GitHub Profile",
                    });
                  }}
                >
                  <img src={github} alt="GitHub Icon" />
                </a>
              </div>

              <a href="/cv.pdf" download onClick={handleDownloadCV} className="cv-download-link">
                <button className="vvd">
                  <span>Download CV</span>
                  <svg className="download-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                    <polyline points="7 10 12 15 17 10"></polyline>
                    <line x1="12" y1="15" x2="12" y2="3"></line>
                  </svg>
                </button>
              </a>
            </span>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Download Confirmation Modal */}
      <DownloadConfirmationModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onConfirm={handleConfirmDownload}
      />
    </Router>
  );
};
